import { Box, Stack } from "@mui/material";
import PropTypes from "prop-types";

function FabBar({ sx, ...props }) {
  return (
    <Box
      sx={[
        {
          position: "absolute",
          zIndex: 1000,
          bottom: 16,
          left: 16,
          right: 16,
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
          alignItems: "flex-end",
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Stack
        direction="row"
        sx={{
          gap: 1,
          alignItems: "center",
          justifyContent: "flex-end",
          position: "fixed",
        }}
      >
        {props.children}
      </Stack>
    </Box>
  );
}

FabBar.propTypes = {
  sx: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  children: PropTypes.node,
};

export default FabBar;
